
import Vuesax from "../../../assets/duotone/Vuesax.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function VuesaxIcon({ className, dataTestid = "VuesaxIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Vuesax data-testid={dataTestid} className={classes} {...rest} />
  );
}
